import { forwardRef } from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import { es } from 'date-fns/locale'
import { Calendar } from 'lucide-react'
import 'react-datepicker/dist/react-datepicker.css'

// Registrar locale español
registerLocale('es', es)

interface DatePickerProps {
  value?: string | Date | null
  onChange: (date: string) => void
  placeholder?: string
  minDate?: Date
  maxDate?: Date
  disabled?: boolean
  error?: boolean
  className?: string
}

/**
 * DatePicker personalizado con formato DD/MM/YYYY
 * Devuelve el valor en formato YYYY-MM-DD para el backend
 */
export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(
  ({ value, onChange, placeholder = 'DD/MM/AAAA', minDate, maxDate, disabled, error, className }, ref) => {
    // Convertir el valor a Date si es string
    const dateValue = value ? (typeof value === 'string' ? new Date(value) : value) : null

    // Validar que la fecha sea válida
    const validDate = dateValue && !isNaN(dateValue.getTime()) ? dateValue : null

    const handleChange = (date: Date | null) => {
      if (date) {
        // Formatear como YYYY-MM-DD para el backend
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        onChange(`${year}-${month}-${day}`)
      } else {
        onChange('')
      }
    }

    return (
      <div className="relative">
        <ReactDatePicker
          ref={ref as any}
          selected={validDate}
          onChange={handleChange}
          dateFormat="dd/MM/yyyy"
          locale="es"
          placeholderText={placeholder}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          autoComplete="off"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          className={`input pl-10 w-full ${error ? 'border-error-500 focus:ring-error-500' : ''} ${className || ''}`}
          calendarClassName="react-datepicker-custom"
          wrapperClassName="w-full"
        />
        <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
      </div>
    )
  }
)

DatePicker.displayName = 'DatePicker'
